import { CreationSourceEnum } from 'js/src/client';
import { FRESH_ANIMATION_DATA } from 'js/src/components/animated-explainer-videos/constants';
import { migrateAnimationData } from 'js/src/components/animated-explainer-videos/migrations';
import type { AnimationData } from 'js/src/components/animated-explainer-videos/migrations/types/current';

/**
 * The toolbox keeps an animated explainer's style preset, ingredients and shots in the video's
 * `animation_data`, in the GenX editor's own shape, under its migration chain and in its redux
 * slice, so the two share one format. Only the creation source and the editor flag tell the
 * editor's videos from the toolbox's; the data itself does not.
 */

export function isGenxCreationSource(source: CreationSourceEnum | null | undefined): boolean {
    return source === CreationSourceEnum.GENX || source === CreationSourceEnum.GENX_REPEAT;
}

/** The toolbox's starting record: the editor's defaults, but never routed into the editor. */
export function freshToolboxAnimationData(): AnimationData {
    return { ...FRESH_ANIMATION_DATA, isAnimationEditorActive: false };
}

function isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}

/** A saved video's animation data brought to the current shape, or null when it has none. */
export function readAnimatedExplainerState(animationData: unknown): AnimationData | null {
    if (!isRecord(animationData) || typeof animationData.version !== 'number') {
        return null;
    }
    return migrateAnimationData(animationData).data;
}

export function normalizeIngredientName(name: string): string {
    return name
        .trim()
        .replace(/^@/, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
}
